import { render, staticRenderFns } from "./U_BaseBusiness.vue?vue&type=template&id=34701821&scoped=true&"
import script from "./U_BaseBusiness.vue?vue&type=script&lang=js&"
export * from "./U_BaseBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34701821",
  null
  
)

export default component.exports